export const departmentHealthSectionCardSx = {
  border: '0.5px solid',
  borderColor: 'divider',
  borderRadius: '14px',
  px: 2.5,
  py: 2.25,
  mb: 2,
} as const;

export const departmentHealthSectionTitleSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  fontSize: '13px',
  fontWeight: 600,
  color: 'text.primary',
  mb: 0.75,
} as const;

export const departmentHealthSectionSubtitleSx = {
  fontSize: '11.5px',
  color: 'text.secondary',
} as const;
